import { createSlice } from "@reduxjs/toolkit";
import cookie from "js-cookie";
import axios from "axios";
import {
  removeStorageKey,
  writeSafeStorage,
} from "../../../utils/localStorageHelper";

function createCookie(name, value, minutes) {
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + minutes * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

const initialState = {
  accessToken: "",
  accessExpired: "",
  renewToken: "",
  renewExpired: "",
  fullname: "",
  email: "",
  role: 0,
  user_id: 0,
  profile_image: "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, { payload }) => {
      state.accessToken = payload.accessToken;
      state.accessExpired = payload.accessExpired;
      state.renewToken = payload.renewToken;
      state.renewExpired = payload.renewExpired;
      state.fullname = payload.fullname;
      state.email = payload.email;
      state.role = payload.role;
      state.user_id = payload.user_id;
      state.profile_image = payload.profile_image;
      createCookie("accessToken", payload.accessToken, 60);
      createCookie("accessExpired", payload.accessExpired);
      createCookie("renewToken", payload.renewToken);
      createCookie("renewExpired", payload.renewExpired);
      writeSafeStorage("email", payload.email);
      writeSafeStorage("fullname", payload.fullname);
      writeSafeStorage("role", payload.role);
      writeSafeStorage("user_id", payload.user_id);
      writeSafeStorage("profile_image", payload.profile_image);
      writeSafeStorage("no_sip", payload.no_sip);
      writeSafeStorage("address", payload.address);
      writeSafeStorage("phone_number", payload.phone_number);
    },

    /** After profile edit: keep localStorage (and Redux display fields) in sync without re-setting tokens. */
    syncProfileToStorage: (state, { payload }) => {
      if (payload.fullname != null) {
        state.fullname = String(payload.fullname);
        writeSafeStorage("fullname", state.fullname);
      }
      if (payload.email != null) {
        state.email = String(payload.email);
        writeSafeStorage("email", state.email);
      }
      if (payload.profile_image != null) {
        state.profile_image = String(payload.profile_image);
        writeSafeStorage("profile_image", state.profile_image);
      }
      if (payload.phone_number != null) {
        writeSafeStorage("phone_number", String(payload.phone_number));
      }
    },

    renewTokenUser: () => {
      const refreshToken = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_PSEF}psef/renew-token`,
            {
              headers: {
                Authorization: "Bearer " + cookie.get("renewToken"),
              },
            },
          );
          // state.accessToken = response.data.detail.token;
          // state.accessExpired = response.data.detail.token_expired;
          createCookie("accessToken", response.data.detail.token, 60);
          createCookie("accessExpired", response.data.detail.token_expired);
        } catch (error) {
          //
        }
      };
      refreshToken();
    },

    updateTokens: (state, { payload }) => {
      state.accessToken = payload.accessToken;
      state.accessExpired = payload.accessExpired;
      state.renewToken = payload.renewToken;
      state.renewExpired = payload.renewExpired;
      createCookie("accessToken", payload.accessToken, 60);
      createCookie("accessExpired", payload.accessExpired);
      createCookie("renewToken", payload.renewToken);
      createCookie("renewExpired", payload.renewExpired);
    },

    logout: (state) => {
      state.accessToken = null;
      state.accessExpired = null;
      state.renewToken = null;
      state.renewExpired = null;
      cookie.remove("accessToken");
      cookie.remove("accessExpired");
      cookie.remove("renewToken");
      cookie.remove("renewExpired");
      removeStorageKey("email");
      removeStorageKey("fullname");
      removeStorageKey("role");
      removeStorageKey("user_id");
      removeStorageKey("profile_image");
      removeStorageKey("address");
      removeStorageKey("phone_number");
      removeStorageKey("no_sip");
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setUser,
  switchUser,
  logout,
  renewTokenUser,
  syncProfileToStorage,
  updateTokens,
} = authSlice.actions;

export default authSlice.reducer;
